import { useNavigate } from 'react-router-dom'
import { LogOut } from 'lucide-react'
import { useSessionStore } from '@/stores'

interface FooterProps {
  className?: string
}

export const Footer = ({ className = '' }: FooterProps) => {
  const navigate = useNavigate()
  const campaign = useSessionStore(s => s.campaign)
  const canLogoutSession = useSessionStore(s => s.canLogoutSession)()

  const handleLogout = () => {
    navigate('/logout')
  }

  if (!campaign) {
    return null
  }

  return (
    <footer className={`footer ${className}`}>
      {(campaign as any)?.footer_content ? (
        <div className="footer-custom" dangerouslySetInnerHTML={{ __html: (campaign as any).footer_content }} />
      ) : (
        <>
          {canLogoutSession && (
            <div className="flex justify-center mb-3">
              <button type="button" onClick={handleLogout} className="logout-btn">
                <LogOut className="icon" />
                LOG OUT
              </button>
            </div>
          )}

          <div className="powered-by-solvpath">
            <span>Powered by</span>
            <img src="/assets/images/solvpath-logo.svg" alt="SolvPath" className="pointer-events-none select-none" />
          </div>
        </>
      )}
    </footer>
  )
}

export default Footer
